import REMALogo from "../../assets/REMA/logo.svg";
import { FOOTER_LINKS } from "./constants";
import CheckBackground from "./SVGComponents/CheckBackground";
import {
  RiFacebookFill,
  RiInstagramFill,
  RiLinkedinFill,
} from "react-icons/ri";
import footerLogo from "../../assets/REMA/venco-logo-light.svg";
import { Link } from "react-router-dom";
import IFMALogo from "./IFMALogo";

const Footer = () => {
  return (
    <footer className="bg-[#0C2926] text-white relative hidden lg:block  py-[80px]">
      <div className="absolute inset-0 z-[0]">
        <CheckBackground />
      </div>
      <div className="container mx-auto px-4 py-12 relative z-[1]">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
          {/* REMA Logo */}
          <div className="col-span-2 flex flex-col justify-between">
            <img src={REMALogo} alt="" className="w-4/5 max-w-[450px]" />
            <div className="font-inter font-medium text-white text-sm">
              <p>2025 Rema Conference. All rights reserved</p>
            </div>
          </div>

          <div className="col-span-1 hidden 2xl:block"></div>
          {/* Get Involved */}

          <div className=" col-span-4 2xl:col-span-3 flex  justify-between">
            <div className="space-y-10">
              <p className="font-sora text-sm font-medium text-[#6b9e03]">
                Get Involved:
              </p>
              <div className="space-y-8">
                {FOOTER_LINKS.map((link) => (
                  <Link
                    to={link.href}
                    key={link.name}
                    className="font-sora text-sm font-medium text-white block"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
            {/* ORGANIZED BY */}
            <div className="flex gap-8 justify-end flex-col">
              <div className="space-y-5 text-left">
                <p className="font-sora text-sm  text-[#6b9e03]">
                  organized by:
                </p>
                <div className="flex gap-5 items-center ">
                  <a
                    href="https://www.venco.africa/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={footerLogo} alt="" />
                  </a>
                </div>
              </div>
              <div className="bg-white opacity-25 w-px h-full" />
              <div className="space-y-5 text-left">
                <p className="font-sora text-sm  text-[#6b9e03]">
                  endorsed by:
                </p>
                <div className="flex gap-5 items-center ">
                  <IFMALogo />
                </div>
              </div>
            </div>
            {/* SOCIAL MEDIA */}
            <div className="space-y-8 text-right ">
              <p className="font-sora text-sm font-medium text-[#6b9e03]">
                Social Media:
              </p>
              <div className="flex gap-5 items-center justify-end">
                <div className="flex gap-2.5 text-white">
                  <a
                    href="http://faceboook.com/vencohq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 rounded-sm center p-1"
                  >
                    <RiFacebookFill className="text-[28px] " />
                  </a>

                  <a
                    href="http://twitter.com/vencohq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8  rounded-md center p-1"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="white"
                        d="M8 2H1l8.26 11.014L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886L8 2Zm9 18L5 4h2l12 16h-2Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="http://instagram.com/vencohq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8  rounded-md center p-1"
                  >
                    <RiInstagramFill className="text-[28px] " />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/Venco-hq/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8  rounded-md center p-1"
                  >
                    <RiLinkedinFill className="text-[28px] " />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
